import React from 'react';
import { SlideLayout } from './SlideLayout';
import { Star, Sparkles } from 'lucide-react';
export function Slide7_Tiers() {
  const advantagePoints = ['Campaign success ambassadors', 'Campaign success manager', 'Two-day live sales school', 'Active KPI tracking', 'Ongoing consulting and campaign performance enhancement'];
  const tiers = [{
    name: 'ADVANTAGE',
    role: 'System Ownership',
    description: 'A recruiting system that actually works.',
    keyPoints: advantagePoints,
    highlight: true,
    bestFor: 'Teams that want consistency without giving up execution.'
  }, {
    name: 'SUMMIT',
    role: 'Full Execution',
    description: 'Recruiting execution handled for you.',
    keyPoints: advantagePoints,
    extraPoints: ['Dedicated recruiter capacity', 'Final interview execution', 'Enhanced pipeline management and onboarding support'],
    amber: true,
    bestFor: 'Teams that want recruiting off their plate.'
  }, {
    name: 'LEADERSHIP',
    role: 'Executive',
    description: 'Recruit leaders who scale your team.',
    keyPoints: ['Targeted campaigns for operators', 'Interviews handled for you', 'Performance aligned to team output'],
    mint: true,
    bestFor: 'Teams hiring managers and leaders to drive growth.'
  }];
  return <SlideLayout data-id="element-313">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-314">
        <div className="space-y-4 text-center" data-id="element-315">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-316">
            Three Levels of Partnership
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-317">
            Designed to Support Where Your Business Is At Now and In the Future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch max-w-6xl mx-auto" data-id="element-318">
          {tiers.map((tier, idx) => {
          const mintStyle = tier.highlight || tier.mint;
          const containerClasses = mintStyle ? 'bg-slate-800/50 border-[#7FE0C3]/50 ring-2 ring-[#7FE0C3]/20 shadow-2xl' : tier.amber ? 'bg-slate-800/50 border-amber-500/50 ring-2 ring-amber-500/20 shadow-2xl' : 'bg-slate-900/30 border-slate-800';
          const rolePillClasses = mintStyle ? 'bg-[#7FE0C3]/20 text-[#7FE0C3]' : tier.amber ? 'bg-amber-500/20 text-amber-400' : 'bg-slate-800 text-slate-400';
          const bulletClasses = mintStyle ? 'bg-[#7FE0C3]' : tier.amber ? 'bg-amber-500/60' : 'bg-slate-600';
          return <div key={idx} className={`flex flex-col h-full rounded-xl border transition-all relative p-8 ${containerClasses}`} data-id="element-319">
                {tier.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-320">
                    <Star size={12} fill="currentColor" data-id="element-321" />
                    <span data-id="element-322">Most Popular</span>
                  </div>}
                {tier.amber && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-323">
                    <Sparkles size={12} fill="currentColor" data-id="element-324" />
                    <span data-id="element-325">Full Execution</span>
                  </div>}

                <div className="mb-6" data-id="element-326">
                  <h3 className="text-3xl font-bold text-white mb-3" data-id="element-327">
                    {tier.name}
                  </h3>
                  <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider ${rolePillClasses}`} data-id="element-328">
                    {tier.role}
                  </span>
                </div>

                <p className="text-slate-300 text-lg mb-8 leading-relaxed" data-id="element-329">
                  {tier.description}
                </p>

                <div className="mb-8 flex-1" data-id="element-330">
                  <div className="space-y-3" data-id="element-331">
                    {tier.keyPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-332">
                        <span className={`mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 ${bulletClasses}`} data-id="element-333" />
                        <span className="text-slate-300" data-id="element-334">{point}</span>
                      </div>)}
                  </div>

                  {tier.extraPoints && <div className="mt-6 p-4 rounded-lg bg-amber-500/10 border border-amber-500/40 space-y-3" data-id="element-335">
                      <div className="flex items-center text-amber-400 text-xs font-bold uppercase tracking-wider" data-id="element-336">
                        <Sparkles size={12} className="mr-2" data-id="element-337" />
                        <span data-id="element-338">Summit Difference</span>
                      </div>
                      {tier.extraPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-339">
                          <span className="mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 bg-amber-400" data-id="element-340" />
                          <span className="text-white font-medium" data-id="element-341">
                            {point}
                          </span>
                        </div>)}
                    </div>}
                </div>

                <div className={`pt-6 border-t ${tier.amber ? 'border-amber-500/20' : 'border-slate-800'}`} data-id="element-342">
                  <p className="text-sm text-slate-400 leading-relaxed" data-id="element-343">
                    {tier.bestFor}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </SlideLayout>;
}